export default __webpack_public_path__ + "static/alexis-muller1-daeaf4243d9fe5bc23807c7e67502855.png";